import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { CalculatorIllustration } from './Calculator';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const Calculator = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <CalculatorIllustration title={title} />
  </IllustrationWrapper>
);
